/**
 * @fileoverview Initial state for WhatsApp module.
 *
 * @module store/modules/whatsapp/state
 *
 * Defines default state for WhatsApp integration including
 * templates, settings, groups, flows, and download tracking.
 */

import { WhatsAppState } from "./types";

const state: WhatsAppState = {
  templates: [],
  application_settings: {},
  profile_settings: {},
  server_status: false,
  groups: [],
  stickers: [],
  servers: [],
  flows: {
    data: [],
    total: 0,
  },
  selectedFlow: {
    preview: {},
    json: {},
  },
  download: {
    isDownloading: false,
    progress: 0,
    processed: 0,
    total: 0,
    generatedPassword: "",
  },
};

export default state;
